import * as React from 'react';
import { TextField, Show, SimpleShowLayout, DateField } from 'react-admin';

const FeedbackTitle = ({ record }) => {
  return (
    <span>
      Feedback {record ? `"${record.type}"` : 'Feedback type is empty :('}
    </span>
  );
};

export const FeedbackShow = (props) => (
  <Show {...props} title={<FeedbackTitle />}>
    <SimpleShowLayout>
      <TextField source="userId" />
      <TextField label="Feedback type" source="type" />
      <TextField source="detail" />
      <DateField label="Create At" source="createdAt" />
      <TextField source="name" />
      <TextField source="phone" />
    </SimpleShowLayout>
  </Show>
);
